import { useTranslation } from "react-i18next";

import { Button, Tooltip } from "../ui";
import type { DashcamSmsSupport } from "../../hooks/useDashcamLiveVideo";

export interface DashcamRetryProps {
  onRetry: () => void;
  onForce: () => void;
  busy?: boolean;
  smsSupport?: DashcamSmsSupport;
  inline?: boolean;
}

export default function DashcamRetry({
  onRetry,
  onForce,
  busy = false,
  smsSupport = "available",
  inline = false,
}: DashcamRetryProps) {
  const { t } = useTranslation("common");

  const checking = smsSupport === "checking";
  const unavailable = smsSupport === "unavailable";

  const smsButton = (
    <Button
      variant="warningSoft"
      size="xs"
      fullWidth
      loading={checking}
      onClick={onForce}
      disabled={busy || unavailable}
      icon={checking ? undefined : <i className="ri-message-2-line" />}
    >
      {t(checking ? "monitoreoIa.dashcam.smsChecking" : "monitoreoIa.dashcam.retrySms")}
    </Button>
  );

  return (
    <div className={inline ? "mt-1 grid grid-cols-2 gap-1.5" : "mt-1 space-y-1.5"}>
      <Button
        variant="secondary"
        size="xs"
        fullWidth
        onClick={onRetry}
        disabled={busy}
        icon={<i className="ri-refresh-line" />}
      >
        {t("monitoreoIa.dashcam.retryData")}
      </Button>

      {unavailable ? (
        <Tooltip content={t("monitoreoIa.dashcam.smsUnsupported")} position="top">
          {smsButton}
        </Tooltip>
      ) : (
        smsButton
      )}

      {unavailable && (
        <p className="col-span-2 text-[10px] leading-snug text-content-faint">
          {t("monitoreoIa.dashcam.smsUnsupported")}
        </p>
      )}
    </div>
  );
}
